<template>
    <div class="main-box">
        <div class="main-boxs">
            <div class="page-details-dox row">
                <div class="page-details">
                    <router-link :to="{path:'/product/hetong'}">
                        <img class="page-details-img" src="../../../static/image/main/mainP4.png" v-if="enter==null"/>
                        <img class="page-details-img" :src="enter.HaoTong.homePageImage" v-else/>
                    </router-link>
                </div>
                <div class="page-details-text">
                    <!--          <div :class="[ Proportion > 0.7? 'texts': 'texts-min']">-->
                    <!--            <div :class="[ Proportion > 0.7? 'text-title': 'text-title-min']">血管外科</div>-->
                    <!--            <div :class="[ Proportion > 0.7? 'text-details': 'text-details-min']">-->
                    <div class="texts">
                        <router-link :to="{path:'/product/hetong'}">
                            <div class="text-title" v-if="enter==null">血管外科</div>
                            <div class="text-title" v-else>{{enter.HaoTong.homeName}}</div>
                        </router-link>
                        <div class="text-details" v-if="enter==null">
                            <span>
                                HEMOTHES VASCULAR GRAFT<br>
                            </span>
                            <span class="text-title-SY">
                                郝通<br>
                                人工血管<br>
                                新通道，新生命<br>
                            </span>
                        </div>
                        <div class="text-details" v-else>
                            <span>
                                {{enter.HaoTong.homeEnName}}<br>
                            </span>
                            <span class="text-title-SY">
                                {{enter.HaoTong.name}}<br>
                                {{enter.HaoTong.homeIntroduce1}}<br>
                                {{enter.HaoTong.homeIntroduce2}}<br>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-details-dox row-reverse">
                <div class="page-details">
                    <router-link :to="{path:'/product/meiti'}">
                        <img class="page-details-img" src="../../../static/image/main/mainP5.png" v-if="enter==null">
                        <img class="page-details-img" :src="enter.MeiTi.homePageImage" v-else/>
                    </router-link>
                </div>
                <div class="page-details-text">
                    <!--          <div :class="[ Proportion > 0.7? 'texts': 'texts-min']">-->
                    <!--            <div :class="[ Proportion > 0.7? 'text-title': 'text-title-min']">神经外科与骨科</div>-->
                    <!--            <div :class="[ Proportion > 0.7? 'text-details': 'text-details-min']">-->
                    <div class="texts">
                        <router-link :to="{path:'/product/meiti'}">
                            <div class="text-title" v-if="enter==null">神经外科与骨科</div>
                            <div class="text-title" v-else>{{enter.MeiTi.homeName}}</div>
                        </router-link>
                        <div class="text-details" v-if="enter==null">
                             <span>
                               MEMBTHES<br>
                            </span>
                            <span class="text-title-SY">
                                美替<br>
                                外科隔离膜<br>
                                ( 人造硬脑膜、人造硬脊膜 )
                            </span>
                        </div>
                        <div class="text-details" v-else>
                             <span>
                               {{enter.MeiTi.homeEnName}}<br>
                            </span>
                            <span class="text-title-SY">
                                {{enter.MeiTi.name}}<br>
                                {{enter.MeiTi.homeIntroduce1}}<br>
                                {{enter.MeiTi.homeIntroduce2}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination
                background
                layout="prev, pager, next"
                :page-size="2"
                :total="2"
                hide-on-single-page>
        </el-pagination>
    </div>
</template>

<script>
export default {
  name: 'Pagination',
  data() {
    return {
      Proportion: document.body.clientWidth / document.body.clientHeight
    }
  },
  props: {
    enter: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>

<style>
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        background-color: white;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #400099;
    }

    .page-details {
        width: 50%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .page-details-text {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }

    .page-details-img {
        width: 100%;
    }

    .page-details-dox {
        display: flex;
        justify-content: space-between;
        align-content: center;
        background-color: white;
        width: 70%;
        padding: 10px;
        color: #4d4d4d;
    }

    .row {
        flex-direction: row;
    }

    .row-reverse {
        flex-direction: row-reverse;
    }

    .main-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 20px 0;
    }

    .text-title {
        font-family: SY-Light;
        font-size: 32px;
        color: #430098;
        margin-bottom: 10%;
    }

    .text-title-min {
        font-family: SY-Light;
        font-size: 18px;
        color: #430098;
        margin-bottom: 10px;
    }

    .text-title-SY {
        font-family: SY-Light;
        /*font-size: 18px;*/
    }

    .text-details {
        font-family: Futura-LT-Light;
        font-size: 18px;
        line-height: 30px;
        color: #4d4d4d;
    }

    .text-details-min {
        font-family: Futura-LT-Light;
        font-size: 12px;
        color: #4d4d4d;
    }

    .texts {
        padding: 0 80px;
    }

    .texts-min {
        padding: 0 10px;
    }

    .main-boxs {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 30px;
    }

    a {
        text-decoration: none;
    }

    .router-link-active {
        text-decoration: none;
    }
</style>
